<script lang="ts">
import { type VariantProps, cva } from "class-variance-authority";

// shadcn-vue Badge, themed to the Cyberfide brand tokens. Named exports must
// live in a plain <script> block — <script setup> cannot contain ES module
// exports.
export const badgeVariants = cva("inline-flex items-center rounded px-2 py-0.5 text-xs font-medium", {
  variants: {
    variant: {
      default: "bg-brand-blue/20 text-brand-blue",
      ok: "bg-status-ok/20 text-status-ok",
      warning: "bg-status-degraded/20 text-status-degraded",
      error: "bg-status-error/20 text-status-error",
      neutral: "bg-brand-slate/20 text-brand-light",
      // REQ-CD-P1-AST-05 — the Assets page's "Undeclared" marker: a bordered,
      // transparent badge whose border/text color is supplied by the caller's
      // class (e.g. border-status-degraded text-status-degraded).
      outline: "border bg-transparent",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});
</script>

<script setup lang="ts">
import { computed } from "vue";
import { cn } from "@/lib/utils";

const props = defineProps<{ variant?: VariantProps<typeof badgeVariants>["variant"]; class?: string }>();
const classes = computed(() => cn(badgeVariants({ variant: props.variant }), props.class));
</script>

<template>
  <span :class="classes"><slot /></span>
</template>
